import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const FORM_VERIFIED = {
  type: GQL.message_template_type_enum.FormVerified,
  emailSubject: "Your {{organization.name}} form has been verified",
  emailHtml: html`<p>
    Dear {{parent.name}},<br />
    <br />
    Your {{organization.name}} form for {{student.name}} for the
    {{enrollmentPeriod.name}} has been verified.<br />
    <br />
    If you have any questions, please contact {{organization.name}}.<br />
    <br />
    -{{organization.name}} Team<br />
  </p>`,
  emailText: `Dear {{parent.name}},

Your {{organization.name}} form for {{student.name}} for the {{enrollmentPeriod.name}} has been verified.

If you have any questions, please contact {{organization.name}}.

-{{organization.name}} Team`,
  sms: "Your {{organization.name}} form for {{student.name}} for the {{enrollmentPeriod.name}} has been verified. If you have any questions, please contact {{organization.name}}.",
};
